import { Component, HostListener, OnInit } from '@angular/core';
import { NavService, Menu } from '../../../shared/service/nav.service';

@Component({
  selector: 'app-cyclops-nav',
  templateUrl: './cyclops-nav.component.html',
  styleUrls: ['./cyclops-nav.component.scss']
})
export class cyclopsNavComponent implements OnInit {
  menuItems: Menu[] = [];
  mobileMenuOpen = false;

  constructor(private navService: NavService) {}

  ngOnInit() {
    this.navService.items.subscribe(items => {
      this.menuItems = items;
    });
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  toggleSubMenu(item: Menu) {
    item.open = !item.open;
  }

 
  @HostListener("window:scroll", [])
  onWindowScroll() {
    const navbar = document.querySelector(".navbar");
    if (window.scrollY > 50) {
      navbar?.classList.add("scrolled");
    } else {
      navbar?.classList.remove("scrolled");
    }
  }
}
